import React from "react";
import FormRowSplit from "./FormRowSplit";
import FormRowLabel from "./FormRowLabel";

const FormRowSplitLabelled = (props) => {
    return (
        <div className={`grid-x grid-margin-x form-row ${props.className}`}>
            <div className="cell small-3 form-label">
                <FormRowLabel
                    label={props.label}
                    required={props.required}
                    tooltip={props.tooltip}
                />
            </div>
            <div className="cell small-9 form-inputs">
                {
                    <FormRowSplit errorMessages={props.errorMessages}>
                        {props.children}
                    </FormRowSplit>
                }
            </div>
        </div>
    );
}

export default FormRowSplitLabelled;
